import io from 'socket.io-client';

export class Socket {
  constructor(socket_base) {
    this.socket = null;
    this.base = socket_base;
  }
  async connectSocket() {
    this.socket = io(`${this.base}`);
    return this.socket;
  }
}
